/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Not_Found_Or_No_AccessInputs */



/**
* | output |
* | --- |
* | "This artifact doesn't exist or you no longer have access to it." |
*
* @param {Artifact_Not_Found_Or_No_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_not_found_or_no_access = /** @type {((inputs?: Artifact_Not_Found_Or_No_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Not_Found_Or_No_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Artefakt existiert nicht oder du hast keinen Zugriff mehr darauf.")
	return /** @type {LocalizedString} */ ("This artifact doesn't exist or you no longer have access to it.")
});